import React, { useEffect, useState,Fragment } from 'react'
import { Card, Col, Container, Form, Row,InputGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {formato_rut, isValidParam} from '../../../common/Formatos'
import { obtenerRutPropietario } from '../../../store/actions/implicado-action'

const Propietario = ({formik,setRutPropietarioFinal}) => {
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form_implicado, antecedentesCasos } = data_datos_generales
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { datosPantalla, comboPais,comboComunas } = data_datos_implicado
  const [datosSiniestro, setDatosSiniestro] = useState({})

  const [rutPropietario, setRutPropietario] = useState('')
  const [rutPropietarioNoFormato, setRutPropietarioNoFormato] = useState('')
  const [nombrePropietario, setNombrePropietario] = useState('')
  const [direccionPropietario, setDireccionPropietario] = useState('')
  const [emailPropietario, setEmailPropietario] = useState('')
  const [paisPropietario, setPaisPropietario] = useState('')
  const [paisMovilPropietario, setPaisMovilPropietario] = useState('')
  const [fonoPropietario, setFonoPropietario] = useState('')
  const [movilPropietario, setMovilPropietario] = useState('')
  const [comunaPropietario, setComunaPropietario] = useState('')
  const [ciudadPropietario, setCiudadPropietario] = useState('')
  const [obsPropietario, setObsPropietario] = useState('')

  const distpatch=useDispatch()
  useEffect(() => {
    
    distpatch(obtenerRutPropietario(rutPropietarioNoFormato))
  }, [rutPropietarioNoFormato])
  
  useEffect(()=>{
    setRutPropietario(
      datosPantalla &&  datosPantalla.datosPantalla[0]['RutPropietario']!==undefined && datosPantalla.datosPantalla[0]['RutPropietario']!==null? 
        formato_rut(
          datosPantalla.datosPantalla[0]['RutPropietario']
          // + datosPantalla.datosPantalla['RutPropietario']
        ):""
    )
    setRutPropietarioNoFormato(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['RutPropietario'] 
        //+ datosPantalla.datosPantalla['dvIdGirador']
    )
    setNombrePropietario(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['NombrePropietario'] !== undefined &&
        datosPantalla.datosPantalla[0]['NombrePropietario'] !== null &&
        datosPantalla.datosPantalla[0]['NombrePropietario'] !== ''
        ? datosPantalla.datosPantalla[0]['NombrePropietario']
        : ''
        
    )
    setDireccionPropietario(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['DireccionPropietario'] !== undefined &&
        datosPantalla.datosPantalla[0]['DireccionPropietario'] !== null &&
        datosPantalla.datosPantalla[0]['DireccionPropietario'] !== ''
        ? datosPantalla.datosPantalla[0]['DireccionPropietario']
        : ''
        
    )
    setEmailPropietario(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['EmailPropietario'] !== undefined &&
        datosPantalla.datosPantalla[0]['EmailPropietario'] !== null &&
        datosPantalla.datosPantalla[0]['EmailPropietario'] !== ''
        ? datosPantalla.datosPantalla[0]['EmailPropietario']
        : ''
        
    )
    setPaisPropietario(18002)
    setPaisMovilPropietario(18002)
    setFonoPropietario(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['FonoPropietario'] !== undefined &&
          datosPantalla.datosPantalla[0]['FonoPropietario'] !== null &&
          datosPantalla.datosPantalla[0]['FonoPropietario'] !== ''
          ? datosPantalla.datosPantalla[0]['FonoPropietario']
          : ''
      )
      setMovilPropietario(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['MovilPropietario'] !== undefined &&
          datosPantalla.datosPantalla[0]['MovilPropietario'] !== null &&
          datosPantalla.datosPantalla[0]['MovilPropietario'] !== ''
          ? datosPantalla.datosPantalla[0]['MovilPropietario']
          : ''
      )
    setComunaPropietario(
    datosPantalla &&
    datosPantalla.datosPantalla[0]['IdComunaPropietario'] !== undefined &&
    datosPantalla.datosPantalla[0]['IdComunaPropietario'] !== null &&
    datosPantalla.datosPantalla[0]['IdComunaPropietario'] !== ''
    ? datosPantalla.datosPantalla[0]['IdComunaPropietario']
    : ''
      )
      if( datosPantalla &&
        datosPantalla.datosPantalla[0]['IdComunaPropietario'] !== undefined &&
        datosPantalla.datosPantalla[0]['IdComunaPropietario'] !== null &&
        datosPantalla.datosPantalla[0]['IdComunaPropietario'] !== ''){
        const comunaActual = comboComunas &&
          comboComunas.comboComunas?.find(
            (c) => c.id ===datosPantalla.datosPantalla[0]['IdComunaPropietario']
          )
          setCiudadPropietario(comunaActual && comunaActual.atr4)
        }
    if (datosPantalla && isValidParam(datosPantalla.datosPantalla[0]['obsPropietario'])) {
      setObsPropietario(datosPantalla.datosPantalla[0]['obsPropietario']);
    }
},[datosPantalla])
  return (
      <>
      {/* <Container> */}
    <Card className='mt-1 '>
      <Card.Header className='mt-0 mb-0' as='h6' style={{backgroundColor:"#D9EDF6", color:"#8578CD"}}>
        {cfg_form_implicado ? cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-title-tabprop'] : null}
      </Card.Header>
      <Container>
        {cfg_form_implicado ? (
          <div>
            <Row>
              <Col md="3">
                <Form.Label
                  className='mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-rutprop']}
                </Form.Label>{' '}
                <br />
                <Form.Control
                    className='mt-2 w-75'
                    autoComplete='off'
                    value={(formik.values.rutPropietario = rutPropietario)}
                    onChange={(e) => {
                      formik.handleChange(e)
                      setRutPropietario(e.target.value)
                      setRutPropietarioNoFormato(e.target.value)                    
                  
                    }}
                    onFocus={() =>
                      rutPropietario !== ''
                        ? setRutPropietario(rutPropietarioNoFormato)
                        : ''
                    }
                    onBlur={() => {
                      setRutPropietario(formato_rut(rutPropietario))
                    }}
                    name='rutPropietario'
                    error={formik.errors.rutPropietario}
                  ></Form.Control>
                  {formik.errors.rutPropietario ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.rutPropietario}
                    </Form.Text>
                  ) : (
                    ''
                  )}
              </Col>
              <Col md="4">
                <Form.Label
                  className=' mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-nomprop']}
                </Form.Label>
                <br />
                <Form.Control
                    className='mt-2 w-75'
                   
                    value={(formik.values.nombrePropietario = nombrePropietario!==undefined && nombrePropietario)}
                    onChange={(e) => {
                      formik.handleChange(e)
                      setNombrePropietario(e.target.value)
                    }}
                    name='nombre'
                    error={formik.errors.nombrePropietario}
                  ></Form.Control>
                  {formik.errors.nombrePropietario ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.nombrePropietario}
                    </Form.Text>
                  ) : (
                    ''
                  )}
              </Col>
              <Col md="4">
                <Form.Label
                  className='mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-dirprop']}
                </Form.Label>
                <br />
                <Form.Control
                    className='mt-2'
                    value={
                      (formik.values.direccionPropietario =
                        direccionPropietario !== undefined && direccionPropietario)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setDireccionPropietario(e.target.value)
                    }}
                    name='direccionPropietario'
                    error={formik.errors.direccionPropietario}
                  ></Form.Control>
                  {formik.errors.direccionPropietario ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.direccionPropietario}
                    </Form.Text>
                  ) : (
                    ''
                  )}
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <Form.Label
                  className='mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-emailprop']}
                </Form.Label>
                <br />
                <Form.Control
                    className='mt-2'
                    value={
                      (formik.values.emailPropietario =
                        emailPropietario !== undefined && emailPropietario)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setEmailPropietario(e.target.value)
                    }}
                    name='emailPropietario'
                    error={formik.errors.emailPropietario}
                  ></Form.Control>
                  {formik.errors.emailPropietario ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.emailPropietario}
                    </Form.Text>
                  ) : (
                    ''
                  )}
              </Col>
              <Col md="4">
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-fonoprop']}
                </Form.Label>
                <br />
                <InputGroup className='mb-3 w-75'>
                  <Form.Select
                      className='mt-2 w-25'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)

                        setPaisPropietario(e.target.value)
                        
                      }}
                      name='paisPropietario'
                      value={(formik.values.paisPropietario = paisPropietario)}
                      error={formik.errors.paisPropietario}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboPais && comboPais.comboPais?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.paisPropietario ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.paisPropietario}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                    <Form.Control
                    className='mt-2 w-50'
                    value={
                      (formik.values.fonoPropietario =
                        fonoPropietario !== undefined && fonoPropietario)
                    }
                    onKeyDown={(e)=>{
                     //validaNumeros(e)
                    }}
                    onChange={(e) => {
                      formik.handleChange(e)
                      setFonoPropietario(e.target.value)
                    }}
                    name='fonoPropietario'
                    error={formik.errors.fonoPropietario}
                  ></Form.Control>
                  {formik.errors.fonoPropietario ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.fonoPropietario}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                  </InputGroup>
              </Col>
              <Col md="4">
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-movilprop']}
                </Form.Label>
                <br />
                <InputGroup className='mb-3 w-75'>
                  <Form.Select
                      className='mt-2 w-25'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)

                        setPaisMovilPropietario(e.target.value)
                        
                      }}
                      name='paisMovilPropietario'
                      value={(formik.values.paisMovilPropietario = paisMovilPropietario)}
                      error={formik.errors.paisMovilPropietario}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboPais && comboPais.comboPais?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.paisMovilPropietario ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.paisMovilPropietario}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                    <Form.Control
                    className='mt-2 w-50'
                    value={
                      (formik.values.movilPropietario =
                        movilPropietario !== undefined && movilPropietario)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setMovilPropietario(e.target.value)
                    }}
                    name='movilPropietario'
                    error={formik.errors.movilPropietario}
                  ></Form.Control>
                  {formik.errors.movilPropietario ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.movilPropietario}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                  </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-comunaprop']}
                </Form.Label>
                <br />
                <InputGroup className='mb-3 w-75'>
                  <Form.Select
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    onChange={(e) => {
                      formik.handleChange(e)
                      const comunaActual=comboComunas && comboComunas.comboComunas?.find(c=>c.id===e.target.value)
                      setCiudadPropietario(comunaActual.atr4)
                      setComunaPropietario(e.target.value)
                      
                    }}
                    name='comuna'
                    value={(formik.values.comunaPropietario = comunaPropietario)}
                    error={formik.errors.comunaPropietario}
                    >
                    <option value={''}>Seleccione...</option>
                    {comboComunas && comboComunas.comboComunas?.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                  </Form.Select>
                  {formik.errors.comunaPropietario ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.comunaPropietario}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </InputGroup>
              </Col>
              <Col>
                <Form.Label
                  className='mb-2'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-ciudadprop']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                  {ciudadPropietario}
                </Form.Text>
              </Col>
            </Row>
            <Row>
                <Col md="10">
                  <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-obsprop'] ? cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-obsprop'] : "Observaciones"}
                  </Form.Label>
                  <br />
                  <Form.Control as="textarea" 
                    className='mt-2 mb-2' 
                    rows={2} 
                    onChange={e=>{                    
                      formik.handleChange(e)
                      setObsPropietario(e.target.value)                        
                    }}
                    name='obsPropietario'                   
                    value={formik.values.obsPropietario = obsPropietario}
                    error={formik.errors.obsPropietario}  
                  />
                  {formik.errors.obsPropietario ? (
                    <Form.Text variant="danger" style={{color:"red"}} >
                      {formik.errors.obsPropietario}
                    </Form.Text>
                  ) : "" }
                  
                </Col>
              </Row>
            <Row><Col><br></br></Col></Row>
          </div>
        ) : null}
      </Container>
    </Card>


    </>
  )
}

export default Propietario
